// extracted by mini-css-extract-plugin
module.exports = {"history_box":"history_box-OFqkECes"};